<template>
  <v-dialog v-model="dialog" width="300">
    <v-card :color="dialogColor" dark>
      <v-card-text>
        {{ text }}
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import Axios from 'axios';

  export default {
    name: 'SuccessNotification',
    data() {
        let self = this;
      return {
        dialog: false,
        text: 'Success',
        dialogColor: 'success',
        value: 0
      }
    },
    methods: {
      show() {
        this.dialog = true;
      },
      setCurrentValue(value) {
        this.value = value;
      },
      setText(text) {
        this.text = text;
      },
      hide() {
        this.dialog = false;
      },
    }
  }

</script>
